var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "#DCBEBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2731 -2853C-2731 -2879.51 -2709.51 -2901 -2683 -2901H1493C1519.51 -2901 1541 -2879.51 1541 -2853V1042C1541 1068.51 1519.51 1090 1493 1090H-2683C-2709.51 1090 -2731 1068.51 -2731 1042V-2853Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2683 -2900H1493V-2902H-2683V-2900ZM1540 -2853V1042H1542V-2853H1540ZM1493 1089H-2683V1091H1493V1089ZM-2730 1042V-2853H-2732V1042H-2730ZM-2683 1089C-2708.96 1089 -2730 1067.96 -2730 1042H-2732C-2732 1069.06 -2710.06 1091 -2683 1091V1089ZM1540 1042C1540 1067.96 1518.96 1089 1493 1089V1091C1520.06 1091 1542 1069.06 1542 1042H1540ZM1493 -2900C1518.96 -2900 1540 -2878.96 1540 -2853H1542C1542 -2880.06 1520.06 -2902 1493 -2902V-2900ZM-2683 -2902C-2710.06 -2902 -2732 -2880.06 -2732 -2853H-2730C-2730 -2878.96 -2708.96 -2900 -2683 -2900V-2902Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2982,
    transform: "translate(-572 -2801)",
    fill: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 364,
    transform: "translate(-572 -182.519)",
    fill: "#F7F6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6.48145C22 5.38145 21.1 4.48145 20 4.48145H4C2.9 4.48145 2 5.38145 2 6.48145V18.4814C2 19.5814 2.9 20.4814 4 20.4814H20C21.1 20.4814 22 19.5814 22 18.4814V6.48145ZM20 6.48145L12 11.4814L4 6.48145H20ZM20 18.4814H4V8.48145L12 13.4814L20 8.48145V18.4814Z",
    fill: "#CF9F1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2982,
    fill: "white",
    transform: "translate(-572 -2801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c4f915948df90f086aec6b45ee728ef8.svg";
export { ForwardRef as ReactComponent };